import { createApp } from 'vue';
import loveD1PTable from '../../love/D1PTable.vue'
const appElements = document.querySelectorAll('.vue-love-render-d1')

Array.from(appElements).forEach(element => {
    createApp(loveD1PTable).mount(element);
});
